<!--#region FIXED TOGGLE -->
@if (!navService.isMobile()) {
    <button
        class="d-flex align-items-center justify-content-center mt-2 fixed-toggle-btn no-print"
        (click)="navService.toggleNavFixed()"
    >
        @if (navService.isNavFixed()) {
            <fa-icon [icon]="faIconName.faArrowLeft" class="fa-lg"></fa-icon>
        } @else {
            <fa-icon [icon]="faIconName.faArrowRight" class="fa-lg"></fa-icon>
        }
    </button>
}
<!--#endregion-->

<!--#region Nav Logo-->
<div class="nav-header no-print no-pointer">
    <div class="nav-image-ctnr">
        <img src="../assets/images/logos/logo_small.png" height="35px" width="35px" />
    </div>
    @if (mode !== 'Production') {
        <div class="beta-text"></div>
    }
</div>
<!--#endregion-->

<mat-nav-list class="no-print">
    <mat-list-item
        [class.active-nav-parent-item]="navService.selectedMainNav() === 'Home'"
        (click)="navService.homeButtonClick()"
        class="px-2"
    >
        <span class="d-flex flex-row">
            <div class="parent-nav-icon-container">
                <fa-icon [icon]="faIconName.faHouse" class="parent-nav-icon"></fa-icon>
            </div>
            <span class="mr-auto">Home</span>
        </span>
    </mat-list-item>

    <!-- Nav routes from getMainNavRoutes() in nav.service.ts -->
    @for (nav of navService.navRoutes(); track nav) {
        @if (!nav?.isSubNav) {
            @if (nav?.name != '') {
                <ng-container *ngTemplateOutlet="navItem; context: { nav: nav, level: 0 }" />
            }
        }
    }
    <hr />

    <!-- #region USER PROFILE -->
    <mat-list-item
        [class.active-nav-parent-item]="navService.selectedMainNav() === 'profile'"
        (click)="toggleUserProfileSubNav()"
        class="px-2"
    >
        <span class="d-flex flex-row">
            <div class="parent-nav-icon-container">
                <fa-icon [icon]="faIconName.faUser" class="parent-nav-icon"></fa-icon>
            </div>
            <span class="mr-auto">{{ user?.fullName }}</span>
            <fa-icon
                [icon]="faIconName.faAngleDown"
                [class.rotate]="navService.userProfileExpanded()"
                class="dropdown-icon"
            ></fa-icon>
        </span>
    </mat-list-item>
    @if (navService.userProfileExpanded()) {
        <div class="submenu expanded">
            <a
                mat-list-item
                [routerLink]="'users/edit/details/' + user?.id"
                class="px-2"
                (click)="navLinkClicked(nav, level)"
                ><span class="ml-4">My Profile</span></a
            >
            <!-- Logout -->
            <mat-list-item (click)="logout()" class="px-2">
                <span class="ml-4">Logout</span>
            </mat-list-item>
        </div>
    }
    <!-- #endregion -->
    <hr />

    <!-- #region Show Current Event -->
    <mat-list-item class="px-2 no-hover customer-container">
        <span class="d-flex flex-row">
            <div class="parent-nav-icon-container">
                <fa-icon [icon]="faIconName.faVirus" class="parent-nav-icon"></fa-icon>
            </div>
            <span class="customer-name mr-auto">{{ eventName }}</span>
        </span>
    </mat-list-item>
    <!-- #endregion -->

    <!-- #region Change Event -->
    <mat-list-item (click)="openChangeEventModal()" class="px-2 customer-container">
        <span class="d-flex flex-row">
            <div class="parent-nav-icon-container">
                <fa-icon [icon]="faIconName.faSwap" class="parent-nav-icon"></fa-icon>
            </div>
            <span class="customer-name">Change Event</span>
            <fa-icon [icon]="faIconName.faAngleDown" class="dropdown-icon ml-auto"></fa-icon>
        </span>
    </mat-list-item>
    <!-- #endregion -->

    <!-- Anchor element used to check for any off screen nav items -->
    <a id="navAnchor"></a>
</mat-nav-list>

<ng-template #navItem let-nav="nav" let-level="level">
    @if (navService.canViewNav(nav)) {
        <ng-container
            *ngTemplateOutlet="nav?.children?.length ? navItemTree : navItemNode; context: { nav: nav, level: level }"
        />
    }
</ng-template>

<!-- This is an Angular template for a navigation item in a side navigation menu with child records. -->
<ng-template #navItemTree let-nav="nav" let-level="level">
    <mat-list-item
        [class.active-nav-parent-item]="nav?.name === navService.selectedMainNav()"
        (click)="navService.toggleSubNav(nav)"
        class="px-2 pointer"
    >
        <span class="d-flex flex-row" [class.ml-4]="level > 0">
            @if (nav.icon) {
                <div class="parent-nav-icon-container">
                    <fa-icon [icon]="nav.icon" class="parent-nav-icon"></fa-icon>
                </div>
            }
            @if (nav?.name?.length < 17) {
                <a
                    ><span>{{ nav.shortName ?? nav.name }}</span></a
                >
            } @else {
                <a
                    ><span>{{ nav.shortName ?? nav.name.slice(0, 17) }}...</span></a
                >
            }
            <fa-icon
                [icon]="faIconName.faAngleDown"
                [class.rotate]="nav.expanded"
                class="dropdown-icon ml-auto"
            ></fa-icon>
        </span>
    </mat-list-item>
    @if (nav.expanded) {
        <div class="submenu expanded">
            @for (subNav of nav.children; track subNav) {
                <ng-container *ngTemplateOutlet="navItem; context: { nav: subNav, level: level + 1 }" />
            }
        </div>
    }
</ng-template>

<!--
        This is an Angular template for an end navigation item in a side navigation menu.
        It displays a list item with an icon, label, and optional loading spinner.
        The list item is clickable and can navigate to a specific route or URL.
        The `navLinkClicked` function is called when the list item is clicked, passing the name and level of the navigation item.
        The `navLinkIsLoading` function is used to determine whether to display a loading spinner.
        -->
<ng-template #navItemNode let-nav="nav" let-level="level">
    @if (nav?.name != null) {
        <a
            mat-list-item
            (click)="navLinkClicked(nav?.name, level, nav?.openNewTab, nav?.path)"
            [class.active-nav-parent-item]="nav?.name === navService.selectedMainNav()"
            [disabled]="navLinkIsLoading(nav?.name, level)"
            [routerLink]="!nav?.href?.length ? nav?.path : nav?.href"
            class="px-2 pointer"
        >
            <span class="d-flex flex-row" [class.ml-4]="level > 0">
                @if (nav?.icon) {
                    <div class="parent-nav-icon-container">
                        <fa-icon [icon]="nav?.icon" class="parent-nav-icon"></fa-icon>
                    </div>
                }
                @if (nav?.name?.length < 17) {
                    <span>{{ nav?.shortName ?? nav?.name }}</span>
                } @else {
                    <span container="body" [ngbTooltip]="nav?.name" placement="left">
                        {{ nav?.shortName ?? nav?.name.slice(0, 17) }}...
                    </span>
                }
                @if (navLinkIsLoading(nav?.name, level)) {
                    <span
                        class="spinner-border spinner-border-sm align-middle ml-2 my-1"
                        role="status"
                        aria-hidden="true"
                    ></span>
                }
            </span>
        </a>
    }
</ng-template>

@if (navContentOffscreen) {
    <div class="bg-secondary rounded px-3 text-center cursor-pointer scroll-down-position" (click)="scrollToBottom()">
        <fa-icon [icon]="faIconName.faAngleDown" class="text-white"></fa-icon>
    </div>
}

<ng-template #modalChangeEvent let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Change Event</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <select
            #selectEvent
            class="form-control"
            (change)="changeEvent(selectEvent.value)"
            ngDefaultControl
            [(ngModel)]="currentEventId"
            [ngModelOptions]="{ standalone: true }"
        >
            @for (item of eventItems; track item) {
                <option [value]="item.value" class="form-control">
                    {{ item.text }}
                </option>
            }
        </select>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-cancel btn-lg" (click)="modal.dismiss()">Cancel</button>
        <button type="button" class="btn btn-save btn-lg" (click)="saveChangeEvent(modal)">Change Event</button>
    </div>
</ng-template>
